import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import DesignerPreview from './DesignerPreview.js';
import DesignerBackgroundSelect from './DesignerBackgroundSelect.js';
import DesignerColorSelect from './DesignerColorSelect.js';
import DesignerFontSelect from './DesignerFontSelect.js';
import DesignerPerspectiveEditor from './DesignerPerspectiveEditor.js';
import DesignerSymbolSelect from './DesignerSymbolSelect.js';
import DesignerBasketForm from './DesignerBasketForm.js';
import DesignerModeSelect from './DesignerModeSelect.js';
import DesignerPerspectiveSelect from './DesignerPerspectiveSelect.js';
import DesignConfirmModal from './DesignConfirmModal.js';
import Symbol from './Symbol.js';
import { shuffle, copy, array_move_first, guid, copy_float, isEmpty } from './functions.js';

import FontAwesome from 'react-fontawesome';
import update from 'immutability-helper';
import FontFaceObserver from 'fontfaceobserver';
import DesignerUserUpload from "./DesignerUserUpload";
// import "ie-array-find-polyfill";

class ProductDesigner extends React.Component {

    constructor(props) {
        super(props);

        this.designerDebug('init: ', this.props.designerInitConfig);

        this.state = {
            designerConfigInterfaceUrl: '',
            activeBackground: null,
            activeBackgroundVariant: null,
            activePerspectiveGroupVariant: null,
            activePerspective: null,
            activeColor: null,
            activeFont: null,
            activeTexts: null,
            activeLayerIndex: -1,
            designerConfig: null,
            activeDesignerVariants: null,
            activeProductVar: null,
            selectAutoscaleSymbol: null,
            designerMode: null,
            designerArticleId: null,
            designerHasComplex: this.props.designerInitConfig.designerHasComplex,
            designerHasSimple: this.props.designerInitConfig.designerHasSimple,
            designerLoadedDesign: null,
            designerSelectedColor: null,
            designerSelectedSize: null,
            basketAmount: 1,
            designConfirmStatus: -1,
            designerSubmitMode: this.props.designerSubmitMode,
            isDesignerAddonMode: false,
            exportSizeVar: null,
            addonArticleName: '',
            addonBasketArticleId: '',
            colorPerElement: false,
            selectAutoscaleColor: null,
            enableUserUpload: false,
            userUploadInterface: '',
        };

        this.exportDirectScaling = 0;

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleEmptyCallback = this.handleEmptyCallback.bind(this);
        this.handleDesignerModeSelect = this.handleDesignerModeSelect.bind(this);
        this.handleAddToBasket = this.handleAddToBasket.bind(this);
        this.handleEditSave = this.handleEditSave.bind(this);
        this.handleVarSelect = this.handleVarSelect.bind(this);
        this.handleSymbolSelect = this.handleSymbolSelect.bind(this);
        this.handleBackgroundSelect = this.handleBackgroundSelect.bind(this);
        this.handleColorSelect = this.handleColorSelect.bind(this);
        this.handleFontSelect = this.handleFontSelect.bind(this);
        this.handleDesignerConfirm = this.handleDesignerConfirm.bind(this);
        this.handlePerspectiveLayerSelect = this.handlePerspectiveLayerSelect.bind(this);
        this.handleContentLayerChange = this.handleContentLayerChange.bind(this);
        this.handleContentLayerSelect = this.handleContentLayerSelect.bind(this);
        this.handleContentLayerRemove = this.handleContentLayerRemove.bind(this);
        this.handleUserImageSelect = this.handleUserImageSelect.bind(this);
    }

    getExportScaling() {
        if (this.props.designerExportScaling > this.exportDirectScaling)
            return this.props.designerExportScaling / this.exportDirectScaling;
        else
            return 1;
    }

    designerDebug() {
        if (this.props.designerDebug !== null && this.props.designerDebug !== undefined && this.props.designerDebug && window.console)
        {
            console.log.apply(this, arguments);
        }
    }

    handleDesignerModeSelect(mode) {
        if (mode == undefined)
            mode = 'simple';

        if (this.state.designerMode != mode)
        {
            this.setState({
                designerMode: mode
            }, function(){
                if (this.state.designerConfig === null)
                {
                    this.handleDesignerModeSelect(mode);
                }
            });
        }
        else
        {
            this.getProductDesignerConfig(this.state.designerArticleId, this.state.designerLoadedDesign, mode);
        }
    }

    getProductDesignerConfig(articleId, design, mode) {
        return fetch(this.state.designerConfigInterfaceUrl + articleId + '&mode=' + mode)
        .then((response) => response.json())
        .then((responseJson) => {
            this.designerDebug('loaded designerConfig: ', responseJson);
            this.designerDebug('loaded design: ', design);

            let colorPerElement = false;
            if (responseJson.color_per_element)
                colorPerElement = true;

            let enableUserUpload = false;
            if (responseJson.enable_user_upload)
                enableUserUpload = true;

            // set default color
            let activeColor = null;
            if (design !== null && design.activeColor !== undefined)
            {
                activeColor = responseJson.colors.find(col => {
                    return col.id == design.activeColor.id;
                });
            }
            if (activeColor === null && responseJson.colors.length > 0)
                activeColor = responseJson.colors[0];

            let activeBackgroundVariant = null;
            const backgroundVars = responseJson.variants.designer.find((vr) => { return vr.isBackground == '1'});
            if (backgroundVars !== undefined)
            {
                activeBackgroundVariant = backgroundVars.vars[0];

                if (this.state.designerSelectedColor !== null)
                {
                    activeBackgroundVariant = backgroundVars.vars.find((bg) => {
                        return bg.id == this.state.designerSelectedColor;
                    });
                }
            }


            let activePerspectiveGroupVariant = null;
            const persGroupVars = responseJson.variants.designer.find((vr) => { return vr.isPersGroup == '1'});
            if (persGroupVars !== undefined)
                activePerspectiveGroupVariant = persGroupVars.vars[0];


            let symbolCategories = [];
            if (responseJson.symbol_categories !== undefined)
            {
                symbolCategories = responseJson.symbol_categories.map( cat => {
                    return {
                        title: cat.title,
                        symbols: cat.symbols.map( sym => { return new Symbol(sym); })
                    }
                });
            }

            // set default perspectives
            let activePerspective = null;
            let contentLayers = [];
            if (design !== null && design.contentLayers !== undefined)
            {
                contentLayers = design.contentLayers;
            }
            else if (responseJson.perspectives.length > 0)
            {
                contentLayers = this.getTextContentLayers(responseJson.perspectives, responseJson.variants.designer, activeColor, colorPerElement)
            }

            if (responseJson.perspectives.length > 0)
            {
                // get perspective from config
                if (this.props.designerExportPerspective !== null)
                {
                    activePerspective = responseJson.perspectives.find((pers) => {
                        return pers.id == this.props.designerExportPerspective;
                    });
                }

                if (activePerspective === null || activePerspective === undefined)
                    activePerspective = responseJson.perspectives[0];
            }

            let activeDesignerVariants = [];
            if (responseJson.variants.designer.length > 0)
            {
                for (var dvarI = 0; dvarI < responseJson.variants.designer.length; dvarI++) {
                    activeDesignerVariants.push({
                        id: responseJson.variants.designer[dvarI].id,
                        isArticle: responseJson.variants.designer[dvarI].isArticle,
                        isBackground: responseJson.variants.designer[dvarI].isBackground,
                        isExportSize: responseJson.variants.designer[dvarI].isExportSize,
                        isPersGroup: responseJson.variants.designer[dvarI].isPersGroup,
                        selectedVar: null,
                        varUserSelected: (responseJson.variants.designer[dvarI].isBackground == "1"),
                        title: responseJson.variants.designer[dvarI].title,
                    });
                }

                for (var davarI = 0; davarI < activeDesignerVariants.length; davarI++) {
                    if (activeDesignerVariants[davarI].isBackground == "1")
                    {
                        activeDesignerVariants[davarI].selectedVar = activeBackgroundVariant;
                    }
                    if (activeDesignerVariants[davarI].isPersGroup == "1")
                    {
                        activeDesignerVariants[davarI].selectedVar = activePerspectiveGroupVariant;
                    }
                }
            }


            // set default background
            let activeBackground = null;
            if (responseJson.backgrounds.length > 0)
            {
                activeBackground = responseJson.backgrounds[0];

                if (activeBackgroundVariant !== null && activePerspective !== null)
                {
                    activeBackground = responseJson.backgrounds.find((bg) => {
                        return bg.background_id == activeBackgroundVariant.id &&
                            bg.perspective_id == activePerspective.id &&
                            bg.perspective_varid == activePerspective.varid
                    });
                }

                // if (this.props.designerRenderMode == 'exportresult' || this.props.designerRenderMode == 'preview')
                // {
                //     activeBackground = responseJson.backgrounds.find((bg) => {
                //         return bg.id == design.backgroundId
                //     });
                //
                //     if (backgroundVars && activeBackground)
                //     {
                //         activeBackgroundVariant = backgroundVars.vars.find((bgv) => {
                //             return bgv.id == activeBackground.background_id;
                //         });
                //     }
                // }
            }

            // set selected variant
            let activeProductVar = null;
            if (design !== null && design.activeProduct !== undefined)
            {
                activeProductVar = responseJson.variants.article.find((artvar) => {
                    return artvar.oxid == design.activeProduct;
                });

                this.designerDebug('article selected from design: ', activeProductVar);

                if (activeProductVar !== null && activeProductVar !== undefined)
                {
                    const varSelectParts = responseJson.variants.select.split('|');
                    const varNameParts = activeProductVar.varSelect.split('|');

                    //  color | size => ['color', 'size']
                    for (var varSelI = 0; varSelI < varSelectParts.length; varSelI++) {

                        // find designer variant group
                        for (var desVarGrpI = 0; desVarGrpI < responseJson.variants.designer.length; desVarGrpI++) {

                            var desVarGrp = responseJson.variants.designer[desVarGrpI];
                            if (desVarGrp.id == varSelectParts[varSelI].trim())
                            {
                                // find selected variant
                                for (var desVarI = 0; desVarI < desVarGrp.vars.length; desVarI++) {
                                    if (desVarGrp.vars[desVarI].id == varNameParts[varSelI].trim())
                                    {
                                        if (activePerspectiveGroupVariant !== undefined && desVarGrp.isPersGroup == "1")
                                        {
                                            activePerspectiveGroupVariant = desVarGrp.vars[desVarI];
                                            activePerspective = responseJson.perspectives.find(pers =>
                                                pers.id == activePerspective.id && pers.varid == activePerspectiveGroupVariant.id
                                            );
                                        }

                                        // set variant in activeDesignerVariants
                                        for (var davarI = 0; davarI < activeDesignerVariants.length; davarI++) {
                                            if (activeDesignerVariants[davarI].id == desVarGrp.id)
                                            {
                                                activeDesignerVariants[davarI].selectedVar = desVarGrp.vars[desVarI];

                                                // set background varaint
                                                if (desVarGrp.isBackground == "1")
                                                {
                                                    if (activePerspective.varid !== undefined && activePerspective.varid !== null && activePerspective.varid !== '')
                                                    {
                                                        activeBackground = responseJson.backgrounds.find((bg) => {
                                                            return bg.background_id == desVarGrp.vars[desVarI].id &&
                                                                bg.perspective_id == activePerspective.id  &&
                                                                bg.variant_group_id == activePerspective.varid
                                                        });
                                                    }
                                                    else
                                                    {
                                                        activeBackground = responseJson.backgrounds.find((bg) => {
                                                            return bg.background_id == desVarGrp.vars[desVarI].id &&
                                                                bg.perspective_id == activePerspective.id
                                                        });
                                                    }

                                                    activeBackgroundVariant = desVarGrp.vars[desVarI]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

            }
            // set default activeProduct if there is only a color variation
            else if (responseJson.variants.designer.length == 1)
            {
                let variantSelectString = responseJson.variants.select;
                for (var varI = 0; varI < activeDesignerVariants.length; varI++) {
                    if (activeDesignerVariants[varI].selectedVar !== null)
                        variantSelectString = variantSelectString.replace(activeDesignerVariants[varI].id, activeDesignerVariants[varI].selectedVar.id);
                }

                activeProductVar = responseJson.variants.article.find((artvar) => {
                    return artvar.varSelect == variantSelectString;
                });

                if (activeProductVar !== undefined && activeProductVar !== null)
                {
                    const designerSubmitForm = document.getElementById('designerSubmitForm_aid');
                    if (designerSubmitForm !== null)
                    {
                        designerSubmitForm.value = activeProductVar.oxid;
                    }

                    const designerSubmitFormN = document.getElementById('designerSubmitForm_anid');
                    if (designerSubmitFormN !== null)
                    {
                        designerSubmitFormN.value = activeProductVar.oxid;
                    }
                }
            }

            // perspective grouped by var
            if (activePerspectiveGroupVariant !== undefined && activePerspectiveGroupVariant !== null)
            {
                // get perspective from config
                if (this.props.designerExportPerspective !== null)
                {
                    activePerspective = responseJson.perspectives.find((pers) => {
                        return pers.id == this.props.designerExportPerspective && pers.varid == activePerspectiveGroupVariant.id;
                    });
                }
                if (activePerspective === null || activePerspective === undefined || activeProductVar === null || activeProductVar === undefined)
                    activePerspective = responseJson.perspectives.find(pers => pers.varid == activePerspectiveGroupVariant.id);

                activeBackground = responseJson.backgrounds.find((bg) => {
                    return bg.background_id == activeBackgroundVariant.id &&
                        bg.perspective_id == activePerspective.id &&
                        bg.perspective_varid == activePerspective.varid
                });
            }

            // set variant if perspective has varid
            const persGroupVar = activeDesignerVariants.find(desvar => desvar.isPersGroup == "1");
            this.designerDebug('set variant if perspective has varid', activeDesignerVariants, persGroupVar);

            if (persGroupVar !== undefined && persGroupVar.selectedVar === null && persGroupVar.vars.length > 0)
            {
                for (var varpersI = 0; varpersI < activeDesignerVariants.length; varpersI++) {
                    if (activeDesignerVariants[varpersI].isPersGroup == "1")
                        activeDesignerVariants[varpersI].selectedVar = activeDesignerVariants[varpersI].vars[0];
                }
            }


            // set default font
            let activeFont = null;
            if (design !== null && design.activeFont !== undefined)
            {
                activeFont = responseJson.fonts.find(fot => {
                    return fot.id == design.activeFont.id;
                });
            }
            if (activeFont === null && responseJson.fonts.length > 0)
                activeFont = responseJson.fonts[0];

            // set exportresult color and scale (scale export for plotter / mm based)
            if (this.props.designerRenderMode == 'exportresult' && activePerspective !== null && (activePerspective.export_pxbased == undefined || activePerspective.export_pxbased == 0))
            {
                activeColor = {
                    color_hex: "#000000",
                    color_image: "",
                    id: "black",
                    title: "black"
                }

                // scale to exportsize at 72dpi
                this.state.activeDesignerVariants = activeDesignerVariants;
                this.state.activePerspective = activePerspective;
                const designerExportSizeVariants = responseJson.variants.designer.find((vr) => { return vr.isExportSize == '1'});;
                const exportWidthCm = this.getExportWidthtInMm(activePerspective, [], design, designerExportSizeVariants) / 10;
                const totalWidthPx = exportWidthCm * 72 / 2.54;
                const exportWidthScale = totalWidthPx / parseFloat(activePerspective.dimensions.width);

                for (var layerI = 0; layerI < contentLayers.length; layerI++) {
                    contentLayers[layerI].dimensions.posX = contentLayers[layerI].dimensions.posX * exportWidthScale;
                    contentLayers[layerI].dimensions.posY = contentLayers[layerI].dimensions.posY * exportWidthScale;
                    contentLayers[layerI].dimensions.width = contentLayers[layerI].dimensions.width * exportWidthScale;
                    contentLayers[layerI].dimensions.height = contentLayers[layerI].dimensions.height * exportWidthScale;

                    if (contentLayers[layerI].maxDimensions !== undefined)
                    {
                        contentLayers[layerI].maxDimensions.posX = contentLayers[layerI].maxDimensions.posX * exportWidthScale;
                        contentLayers[layerI].maxDimensions.posY = contentLayers[layerI].maxDimensions.posY * exportWidthScale;
                        contentLayers[layerI].maxDimensions.width = contentLayers[layerI].maxDimensions.width * exportWidthScale;
                        contentLayers[layerI].maxDimensions.height = contentLayers[layerI].maxDimensions.height * exportWidthScale;
                    }
                }

                // apply direct scaling if possible
                const maxLengthWidthInPx = 1350;
                if (totalWidthPx < maxLengthWidthInPx && maxLengthWidthInPx / totalWidthPx > 1)
                {
                    this.exportDirectScaling = Math.min(this.props.designerExportScaling, Math.floor(maxLengthWidthInPx / totalWidthPx));
                    // apply direc scaling
                    for (var layerI = 0; layerI < contentLayers.length; layerI++) {
                        contentLayers[layerI].dimensions.posX = contentLayers[layerI].dimensions.posX * this.exportDirectScaling;
                        contentLayers[layerI].dimensions.posY = contentLayers[layerI].dimensions.posY * this.exportDirectScaling;
                        contentLayers[layerI].dimensions.width = contentLayers[layerI].dimensions.width * this.exportDirectScaling;
                        contentLayers[layerI].dimensions.height = contentLayers[layerI].dimensions.height * this.exportDirectScaling;

                        if (contentLayers[layerI].maxDimensions !== undefined)
                        {
                            contentLayers[layerI].maxDimensions.posX = contentLayers[layerI].maxDimensions.posX * this.exportDirectScaling;
                            contentLayers[layerI].maxDimensions.posY = contentLayers[layerI].maxDimensions.posY * this.exportDirectScaling;
                            contentLayers[layerI].maxDimensions.width = contentLayers[layerI].maxDimensions.width * this.exportDirectScaling;
                            contentLayers[layerI].maxDimensions.height = contentLayers[layerI].maxDimensions.height * this.exportDirectScaling;
                        }

                    }
                }


                // reset posX and posY
                for (var persLI = 0; persLI < responseJson.perspectives.length; persLI++) {

                    // get perspectiv layers
                    const persContentLayers = contentLayers.filter(ly => {
                        return ly.perspectiveId ==  responseJson.perspectives[persLI].id;
                    });

                    // resize layers (set maxDimensions pos to 0)
                    if (responseJson.perspectives[persLI].designer_mode == 'resize')
                    {
                        for (var clPI = 0; clPI < persContentLayers.length; clPI++) {
                            // persContentLayers[clPI].dimensions.posX = persContentLayers[clPI].dimensions.posX - persContentLayers[clPI].maxDimensions.posX;
                            // persContentLayers[clPI].dimensions.posY = persContentLayers[clPI].dimensions.posY - persContentLayers[clPI].maxDimensions.posY;

                            persContentLayers[clPI].maxDimensions.posX = 0;
                            persContentLayers[clPI].maxDimensions.posY = 0;
                        }
                    }

                    // autoscale layers move by minX minY
                    else if (responseJson.perspectives[persLI].designer_mode == 'autoscale')
                    {
                        let minX = 0;
                        let minY = 0;

                        for (var clPI = 0; clPI < persContentLayers.length; clPI++) {
                            if (persContentLayers[clPI].dimensions.posX > 0 && (persContentLayers[clPI].dimensions.posX < minX || minX === 0))
                                minX = persContentLayers[clPI].dimensions.posX;

                            if (persContentLayers[clPI].dimensions.posY > 0 && (persContentLayers[clPI].dimensions.posY < minY || minY === 0))
                                minY = persContentLayers[clPI].dimensions.posY;
                        }

                        if (minX > 10) minX -= 10;
                        if (minY > 10) minY -= 10;

                        for (var clPI = 0; clPI < persContentLayers.length; clPI++) {

                            persContentLayers[clPI].dimensions.posY -= minY;
                            persContentLayers[clPI].dimensions.posX -= minX;

                            if (persContentLayers[clPI].maxDimensions !== undefined)
                            {
                                persContentLayers[clPI].maxDimensions.posY -= minY;
                                persContentLayers[clPI].maxDimensions.posX -= minX;
                            }
                        }
                    }
                }
            }
            // scale export px based
            else if (this.props.designerRenderMode == 'exportresult' && activePerspective !== null && activePerspective.export_pxbased != undefined  && activePerspective.export_pxbased == 1)
            {
                this.state.activeDesignerVariants = activeDesignerVariants;
                this.state.activePerspective = activePerspective;

                activeBackground = responseJson.backgrounds.find( (bg) => {
                    return bg.id == design.backgroundId;
                })

                if (design.perspectiveVarid != '')
                {
                    activeBackground = responseJson.backgrounds.find( (bg) => {
                        return bg.id == design.backgroundId &&
                        bg.perspective_varid == design.perspectiveVarid;
                    })

                    activePerspective = responseJson.perspectives.find( (pers) => {
                        return pers.varid == design.perspectiveVarid;
                    })

                    if (this.props.designerExportPerspective !== null)
                    {
                        activePerspective = responseJson.perspectives.find((pers) => {
                            return pers.id == this.props.designerExportPerspective &&
                                pers.varid == design.perspectiveVarid;
                        });
                    }
                }

                var newLayers = [];

                // handle autoscale symbols
                let hasSymbolLeft = false;
                let hasSymbolRight = false;
                let hasSymbolTop = false;
                for (var layerI = 0; layerI < contentLayers.length; layerI++)
                {
                    if (contentLayers[layerI].perspectiveId == activePerspective.id && contentLayers[layerI].perspective_varid == design.perspectiveVarid &&
                        contentLayers[layerI].mode == 'autoscale' && contentLayers[layerI].type == 'symbol' && contentLayers[layerI].content !== null)
                    {
                        if (contentLayers[layerI].symbolPosition == 'top')
                        {
                            hasSymbolTop = true;
                            contentLayers[layerI].dimensions.posX = activePerspective.exportpx_posx + (activePerspective.exportpx_width / 2) - (activePerspective.exportpx_height / 2);
                            contentLayers[layerI].dimensions.posY = activePerspective.exportpx_posy - activePerspective.exportpx_height;
                        }
                        else if (contentLayers[layerI].symbolPosition == 'right')
                        {
                            hasSymbolRight = true;
                            contentLayers[layerI].dimensions.posY = activePerspective.exportpx_posy
                            contentLayers[layerI].dimensions.posX = activePerspective.exportpx_posx + activePerspective.exportpx_width - activePerspective.exportpx_height;

                        }
                        else if (contentLayers[layerI].symbolPosition == 'left')
                        {
                            hasSymbolLeft = true;
                            contentLayers[layerI].dimensions.posY = activePerspective.exportpx_posy
                            contentLayers[layerI].dimensions.posX = activePerspective.exportpx_posx
                        }

                        contentLayers[layerI].dimensions.width = activePerspective.exportpx_height;
                        contentLayers[layerI].dimensions.height = activePerspective.exportpx_height;
                    }
                }

                for (var layerI = 0; layerI < contentLayers.length; layerI++)
                {
                    if (contentLayers[layerI].perspectiveId == activePerspective.id && contentLayers[layerI].perspective_varid == design.perspectiveVarid)
                    {
                        if (contentLayers[layerI].mode == 'autoscale')
                        {
                            if (contentLayers[layerI].type == 'text')
                            {
                                if (contentLayers[layerI].maxDimensions === undefined)
                                    contentLayers[layerI].maxDimensions = {};

                                contentLayers[layerI].maxDimensions.posX = activePerspective.exportpx_posx;
                                contentLayers[layerI].maxDimensions.posY = activePerspective.exportpx_posy;
                                contentLayers[layerI].maxDimensions.width = activePerspective.exportpx_width;
                                contentLayers[layerI].maxDimensions.height = activePerspective.exportpx_height;

                                contentLayers[layerI].dimensions.posX = activePerspective.exportpx_posx;
                                contentLayers[layerI].dimensions.posY = activePerspective.exportpx_posy;
                                contentLayers[layerI].dimensions.width = activePerspective.exportpx_width;
                                contentLayers[layerI].dimensions.height = activePerspective.exportpx_height;

                            }
                            else if (contentLayers[layerI].type == 'image')
                            {
                                if (contentLayers[layerI].maxDimensions === undefined)
                                    contentLayers[layerI].maxDimensions = {};

                                contentLayers[layerI].maxDimensions.posX = activePerspective.exportpx_imgposx;
                                contentLayers[layerI].maxDimensions.posY = activePerspective.exportpx_imgposy;
                                contentLayers[layerI].maxDimensions.width = activePerspective.exportpx_imgwidth;
                                contentLayers[layerI].maxDimensions.height = activePerspective.exportpx_imgheight;

                                contentLayers[layerI].dimensions.posX = 0;
                                contentLayers[layerI].dimensions.posY = 0;
                                contentLayers[layerI].dimensions.width = activePerspective.exportpx_imgwidth;
                                contentLayers[layerI].dimensions.height = activePerspective.exportpx_imgheight;
                            }
                        }
                        else if (contentLayers[layerI].mode == 'resize')
                        {
                            if (contentLayers[layerI].type == 'text' || contentLayers[layerI].type == 'symbol')
                            {
                                if (contentLayers[layerI].maxDimensions !== undefined)
                                {
                                    const exportWidthScale = activePerspective.exportpx_width / contentLayers[layerI].maxDimensions.width;

                                    contentLayers[layerI].maxDimensions.posX = activePerspective.exportpx_posx;
                                    contentLayers[layerI].maxDimensions.posY = activePerspective.exportpx_posy;
                                    contentLayers[layerI].maxDimensions.width = contentLayers[layerI].maxDimensions.width * exportWidthScale;
                                    contentLayers[layerI].maxDimensions.height = contentLayers[layerI].maxDimensions.height * exportWidthScale;

                                    contentLayers[layerI].dimensions.posX = contentLayers[layerI].dimensions.posX * exportWidthScale;
                                    contentLayers[layerI].dimensions.posY = contentLayers[layerI].dimensions.posY * exportWidthScale;
                                    contentLayers[layerI].dimensions.width = contentLayers[layerI].dimensions.width * exportWidthScale;
                                    contentLayers[layerI].dimensions.height = contentLayers[layerI].dimensions.height * exportWidthScale;
                                }
                            }
                            else if (contentLayers[layerI].type == 'image')
                            {
                                if (contentLayers[layerI].maxDimensions === undefined)
                                    contentLayers[layerI].maxDimensions = {};

                                contentLayers[layerI].maxDimensions.posX = activePerspective.exportpx_imgposx;
                                contentLayers[layerI].maxDimensions.posY = activePerspective.exportpx_imgposy;
                                contentLayers[layerI].maxDimensions.width = activePerspective.exportpx_imgwidth;
                                contentLayers[layerI].maxDimensions.height = activePerspective.exportpx_imgheight;

                                contentLayers[layerI].dimensions.posX = 0;
                                contentLayers[layerI].dimensions.posY = 0;
                                contentLayers[layerI].dimensions.width = activePerspective.exportpx_imgwidth;
                                contentLayers[layerI].dimensions.height = activePerspective.exportpx_imgheight;
                            }
                        }
                    }


                    if (contentLayers[layerI].content !== null)
                    {
                        newLayers.push(contentLayers[layerI]);
                    }
                }

                contentLayers = newLayers;
            }
            else if (this.props.designerRenderMode == 'preview' && activePerspective !== null)
            {
                this.state.activeDesignerVariants = activeDesignerVariants;
                this.state.activePerspective = activePerspective;

                activeBackground = responseJson.backgrounds.find( (bg) => {
                    return bg.id == design.backgroundId;
                })

                if (design.perspectiveVarid != '')
                {
                    activeBackground = responseJson.backgrounds.find( (bg) => {
                        return bg.id == design.backgroundId &&
                            bg.perspective_varid == design.perspectiveVarid;
                    })

                    activePerspective = responseJson.perspectives.find( (pers) => {
                        return pers.varid == design.perspectiveVarid;
                    })
                }
            }

            // select activeBackgroundVariant from design if not correct
            if (design !== null && design.backgroundId !== undefined && activeBackgroundVariant.id != activeBackground.background_id)
            {
                const backgroundVars = responseJson.variants.designer.find((vr) => { return vr.isBackground == '1'});
                if (backgroundVars !== undefined)
                {
                    activeBackgroundVariant = backgroundVars.vars.find((bg) => {
                        return bg.id == activeBackground.background_id;
                    });
                }
            }

            // select activePerspective from design if not correct
            if (this.props.designerRenderMode == 'preview' && design !== null && design.backgroundId !== undefined && activePerspective.id != activeBackground.perspective_id)
            {
                activePerspective = responseJson.perspectives.find((pers) => {
                    return pers.id == activeBackground.perspective_id &&
                        pers.varid == activeBackground.perspective_varid;
                });
            }

            // select export background from params
            if (this.props.designerRenderMode == 'exportresult' && design !== null && activePerspective.id != activeBackground.perspective_id)
            {
                activeBackground = responseJson.backgrounds.find((bg) => {
                    return bg.background_id == activeBackgroundVariant.id &&
                        bg.perspective_id == activePerspective.id &&
                        bg.perspective_varid == activePerspective.varid
                });
            }

            // select perspective and background for designer change
            if ((this.props.designerRenderMode == 'designer' || this.props.designerRenderMode == 'minipreview') && design !== null && design.perspectiveVarid !== undefined && design.perspectiveVarid != '')
            {
                console.log('hier letz');
                console.log(activeBackground, activePerspective);
                activeBackground = responseJson.backgrounds.find( (bg) => {
                    return bg.perspective_varid == design.perspectiveVarid &&
                        bg.perspective_id == activeBackground.perspective_id;
                })

                activePerspective = responseJson.perspectives.find( (pers) => {
                    return pers.varid == design.perspectiveVarid;
                })

                console.log(activeBackground, activePerspective);

            }

            // wait for all fonts to load
            const self = this;
            const fontObservers = responseJson.fonts.map(fot =>
                new FontFaceObserver(fot.id)
            );
            Promise.all(fontObservers).then(function () {

                // additional wait
                setTimeout(function(){

                    self.designerDebug('article selected from design is: ', activeProductVar);
                    self.designerDebug('final background is: ', activeBackgroundVariant, activeBackground);
                    self.designerDebug('activeDesignerVariants: ', activeDesignerVariants);
                    self.designerDebug('activeProductVar: ', activeProductVar);
                    self.designerDebug('activePerspective: ', activePerspective);

                    // update state
                    self.setState({
                        designerConfig: responseJson,
                        userUploadInterface: responseJson.user_upload_interface,
                        activeBackgroundVariant: activeBackgroundVariant,
                        activePerspectiveGroupVariant: activePerspectiveGroupVariant,
                        activeBackground: activeBackground,
                        activePerspective: activePerspective,
                        activeColor: activeColor,
                        activeFont: activeFont,
                        activeDesignerVariants: activeDesignerVariants,
                        activeProductVar: activeProductVar,
                        contentLayers: contentLayers,
                        symbolCategories: symbolCategories,
                        colorPerElement: colorPerElement,
                        enableUserUpload: enableUserUpload,
                    }, function(){

                        // set selected size
                        if (this.state.designerSelectedSize !== null && activeProductVar === null)
                        {
                            const sizeVarGroup = activeDesignerVariants.find((varg) => {
                                return varg.id == 'size'
                            });

                            if (sizeVarGroup !== undefined)
                            {
                                const orgVarGroup = responseJson.variants.designer.find((varg) => {
                                    return varg.id == 'size'
                                });

                                const selectedVar = orgVarGroup.vars.find((selvar) => {
                                    return selvar.id == this.state.designerSelectedSize
                                });

                                sizeVarGroup.selectedVar = selectedVar
                                sizeVarGroup.varUserSelected = true;
                                self.handleVarSelect(sizeVarGroup);
                            }
                        }

                    });

                    self.designerDebug('inital state: ', self.state);

                    // execute callback
                    if (typeof window[self.props.designerLoadedCallback] == 'function')
                        window[self.props.designerLoadedCallback]();

                }, 500);

            });
        })
        .catch((error) => {
            console.error(error);
        });
    }

    getStartupTextLayerDimensions(perspective) {

        if (perspective.designer_mode == 'resize')
        {
            const dimensions = copy_float(perspective.dimensions);

            dimensions.posY = 0;
            dimensions.posX = 0;
            dimensions.width = dimensions.width;
            dimensions.height = dimensions.height / 5;

            return dimensions;
        }

        return copy_float(perspective.dimensions);
    }

    getStartupSymbolLayerDimensions(perspective, position) {

        if (perspective.designer_mode == 'resize')
        {
            const dimensionsOrg = copy_float(perspective.dimensions);
            const dimensions = copy_float(perspective.dimensions);

            dimensions.width = dimensionsOrg.width / 4;
            dimensions.height = dimensionsOrg.width / 4;

            if (dimensions.height > dimensionsOrg.height)
            {
                dimensions.width = dimensionsOrg.height;
                dimensions.height = dimensionsOrg.height;
            }

            dimensions.posX = dimensionsOrg.width / 2 - dimensions.width / 2;
            dimensions.posY = dimensionsOrg.height / 2 - dimensions.height / 2;

            return dimensions;
        }
        else if (perspective.designer_mode == 'autoscale' && position == 'left')
        {
            const dimensionsOrg = copy_float(perspective.dimensions);
            const dimensions = copy_float(perspective.dimensions);

            dimensions.width = dimensionsOrg.height -4;
            dimensions.height = dimensionsOrg.height -4;

            return dimensions;
        }
        else if (perspective.designer_mode == 'autoscale' && position == 'right')
        {
            const dimensionsOrg = copy_float(perspective.dimensions);
            const dimensions = copy_float(perspective.dimensions);

            dimensions.posX = dimensionsOrg.posX + dimensionsOrg.width - dimensionsOrg.height + 4;
            dimensions.width = dimensionsOrg.height -4;
            dimensions.height = dimensionsOrg.height -4;

            return dimensions;
        }
        else if (perspective.designer_mode == 'autoscale' && position == 'top')
        {
            const symbolSize = parseFloat(perspective.topsymbol_size);
            const dimensionsOrg = copy_float(perspective.dimensions);
            const dimensions = copy_float(perspective.dimensions);

            dimensions.posY = dimensionsOrg.posY - symbolSize - 4;
            dimensions.posX = dimensionsOrg.posX + ((dimensionsOrg.width - symbolSize) / 2);
            dimensions.width = symbolSize;
            dimensions.height = symbolSize;

            return dimensions;
        }


        return perspective.dimensions;
    }

    getStartupImageLayerDimensions(perspective, background, position) {

        if (perspective.designer_mode == 'resize')
        {
            const dimensionsOrg = copy_float(perspective.dimensions);
            const dimensions = copy_float(perspective.dimensions);

            dimensions.width = dimensionsOrg.width / 4;
            dimensions.height = dimensionsOrg.width / 4;

            if (dimensions.height > dimensionsOrg.height)
            {
                dimensions.width = dimensionsOrg.height;
                dimensions.height = dimensionsOrg.height;
            }

            dimensions.posX = 0;
            dimensions.posY = 0;

            return dimensions;
        }
        else if (perspective.designer_mode == 'autoscale')
        {
            const dimensionsOrg = copy_float(perspective.imageDimensions);
            const dimensions = copy_float(perspective.imageDimensions);

            dimensions.width = dimensionsOrg.width / 4;
            dimensions.height = dimensionsOrg.width / 4;

            if (dimensions.height > dimensionsOrg.height)
            {
                dimensions.width = dimensionsOrg.height;
                dimensions.height = dimensionsOrg.height;
            }

            dimensions.posX = 0;
            dimensions.posY = 0;

            return dimensions;
        }



        return perspective.dimensions;
    }

    getExportWidthtInMm(perspective, designerVars, design, designerExportSizeVariants) {

        // get width from selected variant
        if (this.state.activeDesignerVariants !== null)
        {
            const exportSizeVar = this.state.activeDesignerVariants.find(desvar => {
                return desvar.isExportSize == "1";
            });

            if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
            {
                const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                    return es.perspective_id == this.state.activePerspective.id;
                });

                if (exportSize !== null && exportSize !== undefined)
                {
                    const varExportWidthInMm = parseFloat(exportSize.export_width_mm);
                    if (varExportWidthInMm > 0)
                    {
                        return varExportWidthInMm;
                    }
                }
            }
        }

        // get width from addonsize
        if (design !== undefined && design.addonSize !== undefined && design.addonSize && designerExportSizeVariants)
        {
            const exportSizeVarAddon = designerExportSizeVariants.vars.find(v => {
                return (v.id == design.addonSize)
            });

            const exportSizeAddon = exportSizeVarAddon.export_sizes.find(es => {
                return es.perspective_id == this.state.activePerspective.id;
            });

            return exportSizeAddon.export_width_mm;
        }

        // get width from perspective
        if (perspective.export_width_mm != '0')
        {
            return parseFloat(perspective.export_width_mm);
        }

        // get biggest export width from available variants
        const exportSizeVars = designerVars.find(desvar => {
            return desvar.isExportSize == '1';
        });

        // get exportsize if size is not product var
        if (exportSizeVars === undefined && design !== undefined && design.exportSizeVar !== undefined && design.exportSizeVar && designerExportSizeVariants)
        {
            const exportSizeVarAddon = designerExportSizeVariants.vars.find(v => {
                return (v.id == design.exportSizeVar)
            });

            const exportSizeAddon = exportSizeVarAddon.export_sizes.find(es => {
                return es.perspective_id == this.state.activePerspective.id;
            });

            return exportSizeAddon.export_width_mm;
        }

        let biggestWidthMm = 0;
        for (var varI = 0; varI < exportSizeVars.vars.length; varI++) {
            const persSize = exportSizeVars.vars[varI].export_sizes.find(es => {
                return es.perspective_id == perspective.id;
            });

            if (persSize !== null && persSize.export_width_mm > biggestWidthMm)
                biggestWidthMm = persSize.export_width_mm;
        }

        return biggestWidthMm;
    }

    getExportHeightInMm(perspective, designerVars) {

        return parseFloat(this.getExportWidthtInMm(perspective, designerVars) * perspective.dimensions.height / perspective.dimensions.width);
    }

    getFloatCopyObject(obj) {
        let newObj = copy(obj);
        for (var name in obj) {
            if (obj.hasOwnProperty(name)) {
                newObj[name] = parseFloat(obj[name]);
            }
        }

        return newObj;
    }

    getTextContentLayers(perspectives, designerVars, activeColorPerElelemt, colorPerElement) {

        const layers = [];

        let l = -1;
        perspectives.forEach(function(perspective) {

            let count = 1;
            if (perspective.designer_mode == 'resize')
            {
                count = perspective.max_lines;
            }

            let color = 'inherit';
            if (colorPerElement !== undefined && colorPerElement)
                color = activeColorPerElelemt;

            for (var index = 0; index < count; index++) {
                l++;
                layers.push({
                    id: guid(),
                    perspectiveId: perspective.id,
                    perspective_varid: perspective.varid,
                    dimensions: this.getStartupTextLayerDimensions(perspective),
                    maxDimensions: copy_float(perspective.dimensions),
                    mode: perspective.designer_mode,
                    exportWidthMm: this.getExportWidthtInMm(perspective, designerVars),
                    exportHeightMm: this.getExportHeightInMm(perspective, designerVars),
                    rowIndex: index,
                    type: 'text',
                    content: '',
                    layerIndex: l,
                    color: color,
                });
            }


            if (perspective.designer_mode == 'autoscale' && perspective.is_no_symbols == '0')
            {
                l++;
                layers.push({
                    id: guid(),
                    perspectiveId: perspective.id,
                    perspective_varid: perspective.varid,
                    dimensions: this.getStartupSymbolLayerDimensions(perspective, 'left'),
                    mode: perspective.designer_mode,
                    type: 'symbol',
                    symbolPosition: 'left',
                    content: null,
                    layerIndex: l,
                    color: 'inherit',
                });

                l++;
                layers.push({
                    id: guid(),
                    perspectiveId: perspective.id,
                    perspective_varid: perspective.varid,
                    dimensions: this.getStartupSymbolLayerDimensions(perspective, 'right'),
                    mode: perspective.designer_mode,
                    type: 'symbol',
                    symbolPosition: 'right',
                    content: null,
                    layerIndex: l,
                    color: 'inherit',
                });

                if (perspective.topsymbol_size > 0)
                {
                    l++;
                    layers.push({
                        id: guid(),
                        perspectiveId: perspective.id,
                        perspective_varid: perspective.varid,
                        dimensions: this.getStartupSymbolLayerDimensions(perspective, 'top'),
                        mode: perspective.designer_mode,
                        type: 'symbol',
                        symbolPosition: 'top',
                        content: null,
                        layerIndex: l,
                        color: 'inherit',
                    });
                }
            }

        }, this);

        return layers;
    }



    componentDidMount() {

        if (this.props.designerInitConfig === null || this.props.designerInitConfig === undefined)
            return;

        let isDesignerAddonMode = false;
        let designerHasComplex = false;
        let designerHasSimple = false;
        let designerArticleId = '';
        let designerLoadedDesign = null;
        let designerMode = null;
        let designerSelectedColor = null;
        let designerSelectedSize = null;
        let designerConfigInterfaceUrl = '';
        let addonArticleName = '';
        let addonBasketArticleId = '';

        if (this.props.designerInitConfig.addonArticleName !== undefined)
            addonArticleName = this.props.designerInitConfig.addonArticleName;

        if (this.props.designerInitConfig.addonBasketArticleId !== undefined)
            addonBasketArticleId = this.props.designerInitConfig.addonBasketArticleId;

        if (this.props.designerInitConfig.isDesignerAddonMode !== undefined)
            isDesignerAddonMode = this.props.designerInitConfig.isDesignerAddonMode;

        if (this.props.designerInitConfig.designerConfigInterfaceUrl !== undefined)
            designerConfigInterfaceUrl = this.props.designerInitConfig.designerConfigInterfaceUrl;

        if (this.props.designerInitConfig.designerHasComplex !== undefined)
            designerHasComplex = this.props.designerInitConfig.designerHasComplex;

        if (this.props.designerInitConfig.designerHasSimple !== undefined)
            designerHasSimple = this.props.designerInitConfig.designerHasSimple;

        if (this.props.designerInitConfig.designerArticleId !== undefined)
            designerArticleId = this.props.designerInitConfig.designerArticleId;

        if (this.props.designerInitConfig.designerLoadedDesign !== undefined)
            designerLoadedDesign = this.props.designerInitConfig.designerLoadedDesign;

        if (this.props.designerInitConfig.designerMode !== undefined)
            designerMode = this.props.designerInitConfig.designerMode;

        if (this.props.designerInitConfig.designerSelectedColor !== undefined)
            designerSelectedColor = this.props.designerInitConfig.designerSelectedColor;

        if (this.props.designerInitConfig.designerSelectedSize !== undefined)
            designerSelectedSize = this.props.designerInitConfig.designerSelectedSize;

        this.setState({
            isDesignerAddonMode: isDesignerAddonMode,
            designerConfigInterfaceUrl: designerConfigInterfaceUrl,
            designerHasComplex: designerHasComplex,
            designerHasSimple: designerHasSimple,
            designerArticleId: designerArticleId,
            designerLoadedDesign: designerLoadedDesign,
            designerMode: designerMode,
            designerSelectedSize: designerSelectedSize,
            designerSelectedColor: designerSelectedColor,
            addonArticleName: addonArticleName,
            addonBasketArticleId: addonBasketArticleId
        });
    }
    componentDidUpdate() {
        if (this.state.designerMode !== null && this.state.designerConfig === null)
        {
            this.handleDesignerModeSelect(this.state.designerMode);
        }
    }

    componentWillUnmount() {
    }

    handleBackgroundSelect(bg) {
        this.designerDebug('new background selected: ', bg);

        const backgroundVar = this.state.designerConfig.variants.designer.find((vr) => { return vr.isBackground == '1'});
        const activeBackgroundVariant = backgroundVar.vars.find((vr) => { return vr.id == bg.background_id });

        const newVariant = copy(backgroundVar);
        newVariant.selectedVar = activeBackgroundVariant;
        newVariant.varUserSelected = true;

        this.handleVarSelect(newVariant);
    }

    handleUserImageSelect(image, position) {
        this.designerDebug('new image selected: ', image);

        ReactDOM.findDOMNode(this).scrollIntoView();

        if (this.state.activePerspective.designer_mode == 'resizetest')
        {
            const contentLayers = this.state.contentLayers;
            const symbolCount = contentLayers.filter((ly) => { return
                ly.perspectiveId == this.state.activePerspective.id &&
                ly.mode == 'resize' &&
                (ly.type == 'symbol' && ly.type == 'image')
                ly.perspective_varid == this.state.activePerspective.varid
            }).length

            if (symbolCount < this.getMaxResizeSymbolCount(this.state.activePerspective, this.state.activeDesignerVariants))
            {
                const newLayers = update(contentLayers, {$unshift: [
                        {
                            id: guid(),
                            perspectiveId: this.state.activePerspective.id,
                            perspective_varid: this.state.activePerspective.varid,
                            dimensions: this.getStartupImageLayerDimensions(this.state.activePerspective, this.state.activeBackground, 'resize'),
                            maxDimensions: copy_float(this.state.activePerspective.dimensions),
                            mode: this.state.activePerspective.designer_mode,
                            exportWidthMm: this.getExportWidthtInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                            exportHeightMm: this.getExportHeightInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                            rowIndex: 0,
                            type: 'image',
                            content: image,
                            layerIndex: this.state.contentLayers.length,
                            symbolFlip: false,
                            symbolRotation: null,
                        }
                    ]});

                this.designerDebug('new image: ', newLayers[0]);

                this.setState({
                    contentLayers: newLayers
                });
            }
        }
        else if (this.state.activePerspective.designer_mode == 'autoscale' || this.state.activePerspective.designer_mode == 'resize')
        {
            const imageLayer = this.state.contentLayers.find((ly) => {
                return ly.type == 'image'
            });

            let contentLayers = this.state.contentLayers;
            if (imageLayer !== undefined && imageLayer !== null)
            {
                contentLayers = this.handleContentLayerRemove(imageLayer);
            }

            const newLayers = update(contentLayers, {$unshift: [
                {
                    id: guid(),
                    perspectiveId: this.state.activePerspective.id,
                    perspective_varid: this.state.activePerspective.varid,
                    dimensions: this.getStartupImageLayerDimensions(this.state.activePerspective, this.state.activeBackground, 'autoscale'),
                    maxDimensions: copy_float(this.state.activePerspective.imageDimensions),
                    mode: this.state.activePerspective.designer_mode,
                    exportWidthMm: this.getExportWidthtInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                    exportHeightMm: this.getExportHeightInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                    rowIndex: 0,
                    type: 'image',
                    content: image,
                    layerIndex: this.state.contentLayers.length,
                    symbolFlip: false,
                    symbolRotation: null,
                }
            ]});

            this.designerDebug('new image: ', newLayers[0]);

            this.setState({
                contentLayers: newLayers
            });
        }
    }

    handleSymbolSelect(symbol, position) {
        this.designerDebug('new symbol selected: ', symbol);

        ReactDOM.findDOMNode(this).scrollIntoView();

        if (this.state.activePerspective.designer_mode == 'resize')
        {
            const contentLayers = this.state.contentLayers;
            const symbolCount = contentLayers.filter((ly) => { return ly.perspectiveId == this.state.activePerspective.id && ly.mode == 'resize' && ly.type == 'symbol' && ly.perspective_varid == this.state.activePerspective.varid }).length

            if (symbolCount < this.getMaxResizeSymbolCount(this.state.activePerspective, this.state.activeDesignerVariants))
            {
                let color = 'inherit';
                if (this.state.colorPerElement && this.state.activeColor !== null)
                    color = this.state.activeColor;

                const newLayers = update(contentLayers, {$unshift: [
                    {
                        id: guid(),
                        perspectiveId: this.state.activePerspective.id,
                        perspective_varid: this.state.activePerspective.varid,
                        dimensions: this.getStartupSymbolLayerDimensions(this.state.activePerspective),
                        maxDimensions: copy_float(this.state.activePerspective.dimensions),
                        mode: this.state.activePerspective.designer_mode,
                        exportWidthMm: this.getExportWidthtInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                        exportHeightMm: this.getExportHeightInMm(this.state.activePerspective, this.state.designerConfig.variants.designer),
                        rowIndex: 0,
                        type: 'symbol',
                        content: symbol,
                        layerIndex: this.state.contentLayers.length,
                        symbolFlip: false,
                        symbolRotation: null,
                        color: color,
                    }
                ]});

                this.designerDebug('new symbol: ', newLayers[0]);

                this.setState({
                    contentLayers: newLayers
                });
            }
        }
        else if (this.state.activePerspective.designer_mode == 'autoscale' && position === undefined)
        {
            this.setState({
                selectAutoscaleSymbol: symbol,
                selectAutoscaleColor: null,
            })
        }
        else if (this.state.activePerspective.designer_mode == 'autoscale')
        {
            const symbolLayer = this.state.contentLayers.find((ly) => {
                return ly.perspectiveId == this.state.activePerspective.id &&
                        ly.type == 'symbol' && ly.mode == 'autoscale' && ly.symbolPosition == position
                        && ly.perspective_varid == this.state.activePerspective.varid
            });

            if (symbolLayer !== undefined && symbolLayer !== null)
            {
                symbolLayer.content = symbol;

                let color = 'inherit';
                if (this.state.colorPerElement && this.state.activeColor !== null)
                    color = this.state.activeColor;

                symbolLayer.color = color;

                if (this.state.colorPerElement && (symbolLayer.color !== undefined || symbolLayer.color == 'inherit'))
                    symbolLayer.color = this.state.activeColor;

                this.handleContentLayerChange(symbolLayer);
            }
        }
    }

    handleColorSelect(color, position) {
        this.designerDebug('new color selected: ', color);

        if (this.state.activePerspective.max_lines > 0 && this.state.colorPerElement && this.state.activePerspective.designer_mode == 'autoscale' && position === undefined)
        {
            ReactDOM.findDOMNode(this).scrollIntoView();

            this.setState({
                selectAutoscaleColor: color,
                selectAutoscaleSymbol: null,
            });
        }
        else if (this.state.activePerspective.max_lines > 0 && this.state.colorPerElement && this.state.activePerspective.designer_mode == 'autoscale' && position !== undefined)
        {
            let contentLayer = null;

            if (position == 'text')
            {
                contentLayer = this.state.contentLayers.find((ly) => {
                    return ly.perspectiveId == this.state.activePerspective.id &&
                        ly.type == 'text' && ly.mode == 'autoscale'
                        && ly.perspective_varid == this.state.activePerspective.varid
                });
            }
            else
            {
                contentLayer = this.state.contentLayers.find((ly) => {
                    return ly.perspectiveId == this.state.activePerspective.id &&
                        ly.type == 'symbol' && ly.mode == 'autoscale' && ly.symbolPosition == position
                        && ly.perspective_varid == this.state.activePerspective.varid
                });
            }

            if (contentLayer !== undefined && contentLayer !== null)
            {
                contentLayer.color = color;

                this.setState({
                    activeColor: color,
                    selectAutoscaleColor: null
                });
            }
        }
        else if (this.state.colorPerElement && this.state.activeLayerIndex > -1)
        {
            const contentLayers = this.state.contentLayers;
            if (contentLayers.length >= this.state.activeLayerIndex + 1)
                contentLayers[this.state.activeLayerIndex].color = color;

            this.setState({
                activeColor: color,
                contentLayers: contentLayers
            });

            this.handleContentLayerChange(contentLayers);
        }
        else
        {
            this.setState({
                activeColor: color
            });
        }
    }

    handleFontSelect(font) {
        this.designerDebug('new font selected: ', font);
        this.setState({
            activeFont: font
        });
    }



    handlePerspectiveLayerSelect(perspective, layer) {

        if (perspective.id != this.state.activePerspective.id)
        {
            this.designerDebug('new perspective selected: ', perspective);
            let activeBackground = this.state.activeBackground;
            let activeBackgroundVariant = this.state.activeBackgroundVariant;
            if (activeBackgroundVariant !== null && perspective !== null)
            {
                activeBackground = this.state.designerConfig.backgrounds.find((bg) => {
                    return bg.background_id == activeBackgroundVariant.id &&
                    bg.perspective_id == perspective.id && bg.perspective_varid == perspective.varid
                });
            }

            this.setState({
                activePerspective: perspective,
                activeBackground: activeBackground
            });
        }

        if (layer === undefined || layer === null)
        {
            layer = this.state.contentLayers.find(ly =>
                ly.perspectiveId == perspective.id && ly.perspective_varid == perspective.varid
            );
        }

        if (layer !== undefined && layer !== null)
        {
            for (var l = 0; l < this.state.contentLayers.length; l++) {
                if ((l !== 0 || this.state.activeLayerIndex === -1) && this.state.contentLayers[l].id == layer.id)
                {
                    this.designerDebug('layerselect ', l);
                    this.handleContentLayerSelect(l);
                }
            }
        }
    }

    handleContentLayerChange(layer, selectThisLayer) {
        this.designerDebug('content layer changed: ', layer);

        const contentLayers = this.state.contentLayers;
        let newData = contentLayers;

        for (var l = 0; l < contentLayers.length; l++) {
            if (contentLayers[l].id == layer.id)
            {
                newData = update(newData, {
                    $splice: [[l, 1, layer]]
                });
            }
        }

        // layer ist text and has varid: copy content to same perspective in all varids
        if (layer.type == 'text' && layer.perspective_varid !== null &&
            layer.perspective_varid !== undefined && layer.perspective_varid != '')
        {
            let otherLayers = newData.filter(ly =>
                ly.type == 'text' && ly.perspective_varid != layer.perspective_varid &&
                ly.perspectiveId == layer.perspectiveId && ly.rowIndex == layer.rowIndex
            );

            for (var l = 0; l < newData.length; l++) {
                if (otherLayers.find(ly => ly.id == newData[l].id) !== undefined)
                {
                    newData = update(newData, {
                        [l]: {
                            content: {
                                $set: layer.content
                            }
                        }
                    });
                }
            }
        }

        var self = this;
        this.setState({
            contentLayers: newData,
            selectAutoscaleSymbol: null,
        }, function(){
            if (selectThisLayer === true)
            {
                const pers = self.state.designerConfig.perspectives.find(pers => {
                    return pers.id == layer.perspectiveId && pers.varid == layer.perspective_varid;
                });
                self.handlePerspectiveLayerSelect(pers, layer);
            }
        });


    }

    handleContentLayerSelect(layerIndexKey) {

        let contentLayers = this.state.contentLayers;


        if (this.state.contentLayers.length > layerIndexKey && layerIndexKey > 0)
        {
            this.designerDebug('content layer selected: ', layerIndexKey, this.state.contentLayers);

            const layers = this.state.contentLayers;

            let newData = update(layers, {
                $splice: [[layerIndexKey,1]]
            });

            newData = update(newData, {
                $unshift: [layers[layerIndexKey]]
            });


            let activeColor = this.state.activeColor;
            if (this.state.colorPerElement && newData[0].color !== undefined)
                activeColor = newData[0].color;

            this.setState({
                activeLayerIndex: 0,
                contentLayers: newData,
                selectAutoscaleSymbol: null,
                activeColor: activeColor,
            });

            contentLayers = newData;
        }
        else if (layerIndexKey === -1 && this.state.activeLayerIndex > -1)
        {
            this.designerDebug('content layer selected: ', layerIndexKey, this.state.contentLayers);
            this.setState({
                selectAutoscaleSymbol: null,
                activeLayerIndex: -1
            });
        }
        else if (layerIndexKey == 0 && this.state.activeLayerIndex == -1)
        {
            this.designerDebug('content layer selected: ', layerIndexKey, this.state.contentLayers);

            let activeColor = this.state.activeColor;
            if (this.state.colorPerElement && this.state.contentLayers[0].color !== undefined)
                activeColor = this.state.contentLayers[0].color;

            this.setState({
                selectAutoscaleSymbol: null,
                activeLayerIndex: 0,
                activeColor: activeColor,
            });
        }

        return contentLayers;
    }

    handleContentLayerRemove(layer) {
        this.designerDebug('content layer remove: ', layer);

        const contentLayers = this.state.contentLayers;
        let newData = contentLayers;

        if (layer.type == 'symbol' || layer.type == 'image')
        {
            if (layer.mode == 'resize' || layer.type == 'image')
            {
                for (var l = 0; l < contentLayers.length; l++) {
                    if (contentLayers[l].id == layer.id)
                    {
                        newData = update(newData, {
                            $splice: [[l, 1]]
                        });
                        break;
                    }
                }
            }
            else if (layer.mode == 'autoscale')
            {
                for (var l = 0; l < contentLayers.length; l++) {
                    if (contentLayers[l].id == layer.id)
                    {
                        newData = update(newData, {
                            [l]: {
                                content: {
                                    $set: null
                                }
                            }
                        });
                        break;
                    }
                }
            }
        }
        else if (layer.type == 'text')
        {
            for (var l = 0; l < contentLayers.length; l++) {
                if (contentLayers[l].id == layer.id)
                {
                    newData = update(newData, {
                        [l]: {
                            color: {
                                $set: 'inherit'
                            },
                            content: {
                                $set: ''
                            }
                        }
                    });
                    break;
                }
            }
        }

        this.setState({
            contentLayers: newData
        });

        return newData;
    }

    handleVarSelect(variant) {
        this.designerDebug('var selected: ', variant);

        let currentContentLayers = this.state.contentLayers;

        if (variant.isBackground == "1")
        {
            let activeBackground = this.state.designerConfig.backgrounds.find((bg) => {
                return (bg.background_id == variant.selectedVar.id &&
                    bg.perspective_id == this.state.activePerspective.id &&
                    bg.perspective_varid == this.state.activePerspective.varid)
            });

            this.setState({
                activeBackground: activeBackground,
                activeBackgroundVariant: variant.selectedVar
            });
        }

        let activePerspective = this.state.activePerspective;
        let activePerspectiveGroupVariant = this.state.activePerspectiveGroupVariant;
        if (variant.isPersGroup == "1")
        {
            activePerspectiveGroupVariant = variant.selectedVar;

            if (activePerspective.varid != variant.selectedVar.id)
            {
                activePerspective = this.state.designerConfig.perspectives.find(
                    pers => pers.id == this.state.activePerspective.id && pers.varid == variant.selectedVar.id
                );
            }

            let activeBackground = this.state.designerConfig.backgrounds.find((bg) => {

                if (variant.isBackground == '1' && variant.selectedVar)
                {
                    return (bg.background_id == variant.selectedVar.id &&
                        bg.perspective_id == activePerspective.id &&
                        bg.perspective_varid == activePerspective.varid)
                }

                return (bg.background_id == this.state.activeBackgroundVariant.id &&
                    bg.perspective_id == activePerspective.id &&
                    bg.perspective_varid == activePerspective.varid)
            });

            this.setState({
                activePerspective: activePerspective,
                activeBackground: activeBackground,
            });

            const layer = this.state.contentLayers.find(ly =>
                ly.perspectiveId == activePerspective.id && ly.perspective_varid == activePerspective.varid
            );

            if (layer !== undefined && layer !== null)
            {
                for (var l = 0; l < this.state.contentLayers.length; l++) {
                    if ((l !== 0 || this.state.activeLayerIndex === -1) && this.state.contentLayers[l].id == layer.id)
                    {
                        this.designerDebug('layerselect ', l);
                        currentContentLayers = this.handleContentLayerSelect(l);
                    }
                }
            }
        }

        const activeVars = this.state.activeDesignerVariants;
        let newActiveVars = activeVars;
        for (var l = 0; l < activeVars.length; l++) {
            if (activeVars[l].id == variant.id)
            {
                newActiveVars = update(newActiveVars, {
                    [l]: {
                        selectedVar: {
                            $set: variant.selectedVar
                        },
                        varUserSelected: {
                            $set: (variant.varUserSelected || variant.isBackground == "1")
                        }
                    }
                });
                break;
            }
        }

        let variantSelectString = this.state.designerConfig.variants.select;
        for (var varI = 0; varI < newActiveVars.length; varI++) {
            if (newActiveVars[varI].selectedVar !== null)
                variantSelectString = variantSelectString.replace(newActiveVars[varI].id, newActiveVars[varI].selectedVar.id);
        }

        const activeProductVar = this.state.designerConfig.variants.article.find((artvar) => {
            return artvar.varSelect == variantSelectString;
        });


        if (activeProductVar !== undefined && activeProductVar !== null)
        {
            const designerSubmitForm = document.getElementById('designerSubmitForm_aid');
            if (designerSubmitForm !== null)
            {
                designerSubmitForm.value = activeProductVar.oxid;
            }

            const designerSubmitFormN = document.getElementById('designerSubmitForm_anid');
            if (designerSubmitFormN !== null)
            {
                designerSubmitFormN.value = activeProductVar.oxid;
            }
        }

        // store selected export size var
        let exportSizeVar = null;
        const selectedExportSizeVar = newActiveVars.find(v => { return v.isExportSize; } );
        if (selectedExportSizeVar !== undefined && selectedExportSizeVar && selectedExportSizeVar.selectedVar)
        {
            exportSizeVar = selectedExportSizeVar.selectedVar.id;
        }

        this.setState({
            activeDesignerVariants: newActiveVars,
            activeProductVar: activeProductVar,
            activePerspectiveGroupVariant: activePerspectiveGroupVariant,
            exportSizeVar: exportSizeVar
        });

        // check for max chars
        currentContentLayers = this.checkContentMaxChars(newActiveVars, currentContentLayers);

        // check for blacklisted symbols
        currentContentLayers = this.checkContentBlacklistedSymbols(newActiveVars, currentContentLayers);

        // check for max symbols
        currentContentLayers = this.checkContentMaxSymbols(newActiveVars, currentContentLayers);
    }

    handleEditSave(e) {
        this.handleAddToBasket(e);
    }

    handleDesignerConfirm(confirmed, perspective)
    {
        if (!confirmed && perspective !== null && perspective !== undefined)
        {
            this.setState({
                designConfirmStatus: -1
            });

            this.handlePerspectiveLayerSelect(perspective, null);
        }
        else if (confirmed)
        {
            const designerData = {
                contentLayers: this.state.contentLayers,
                activeColor: this.state.activeColor,
                activeFont: this.state.activeFont,
                designerMode: this.state.designerMode,
                activeProduct: this.state.designerArticleId,
                perspectiveVarid: this.state.activePerspective.varid,
                addonBasketArticleId: this.state.addonBasketArticleId ? this.state.addonBasketArticleId : null,
                addonArticleName: this.state.isDesignerAddonMode ? this.state.addonArticleName : null,
                addonSize: this.state.isDesignerAddonMode ? this.state.designerSelectedSize : null,
                addonColor: this.state.isDesignerAddonMode ? this.state.designerSelectedColor : null,
                exportSizeVar: this.state.exportSizeVar ? this.state.exportSizeVar : null,
                backgroundId: this.state.activeBackground.id,
            }

            if (this.state.activeProductVar !== null && this.state.activeProductVar !== undefined)
            {
                designerData.activeProduct = this.state.activeProductVar.oxid;
            }

            const persistentParam = document.getElementById('persistentParam');
            if (persistentParam !== null)
            {
                const designerDataJson = JSON.stringify(designerData);
                persistentParam.value = designerDataJson;
                this.designerDebug('designer to basket',designerData, designerDataJson);

                const designerSubmitForm = document.getElementById('designerSubmitForm');
                if (designerSubmitForm !== null)
                {
                    designerSubmitForm.submit();
                }
            }
        }
    }

    handleAddToBasket(e) {
        this.setState({designConfirmStatus: 0});
    }

    handleAmountChange(amount) {

        if (this.state.basketAmount != amount) {

            if (!isEmpty(amount))
                amount = parseInt(amount);

            const designerSubmitFormA = document.getElementById('designerSubmitForm_am');
            if (designerSubmitFormA !== null)
            {
                designerSubmitFormA.value = amount;
            }

            this.setState({
                basketAmount: amount
            })
        }
    }

    handleEmptyCallback(e) {

    }

    checkContentBlacklistedSymbols(newActiveVars, currentContentLayers) {

        let contentLayers = currentContentLayers;
        if (currentContentLayers === undefined || currentContentLayers === null)
            contentLayers = this.state.contentLayers;

        let newData = contentLayers;


        const varPerspectives = this.state.designerConfig.perspectives.filter(pers => {
            return pers.varid == this.state.activePerspective.varid;
        });

        for (var persI = 0; persI < varPerspectives.length; persI++) {
            const perspective = varPerspectives[persI];

            const symbolLayers = contentLayers.filter(ly => {
                return ly.content !== null && ly.perspectiveId == perspective.id && ly.type == 'symbol' && ly.perspective_varid == perspective.varid;
            });

            const blacklistedLayers = symbolLayers.filter(ly => {
                return new Symbol(ly.content).isBlacklistedForVariants(newActiveVars);
            });

            if (blacklistedLayers.length > 0)
            {
                for (var lI = 0; lI < blacklistedLayers.length; lI++) {
                    var layer = blacklistedLayers[lI];

                    if (layer.mode == 'resize')
                    {
                        for (var l = 0; l < newData.length; l++) {
                            if (newData[l].id == layer.id)
                            {
                                newData = update(newData, {
                                    $splice: [[l, 1]]
                                });
                                break;
                            }
                        }
                    }
                    else if (layer.mode == 'autoscale')
                    {
                        for (var l = 0; l < newData.length; l++) {
                            if (newData[l].id == layer.id)
                            {
                                newData = update(newData, {
                                    [l]: {
                                        content: {
                                            $set: null
                                        }
                                    }
                                });
                                break;
                            }
                        }
                    }
                }
            }
        }

        this.setState({
            contentLayers: newData
        });

        return newData;
    }

    checkContentMaxSymbols(newActiveVars, currentContentLayers) {

        let contentLayers = currentContentLayers;
        if (currentContentLayers === undefined || currentContentLayers === null)
            contentLayers = this.state.contentLayers;

        let newData = contentLayers;

        const resizePerspectives = this.state.designerConfig.perspectives.filter(pers => {
            return pers.designer_mode == 'resize';
        });

        for (var persI = 0; persI < resizePerspectives.length; persI++) {
            const perspective = resizePerspectives[persI];
            const maxSymbols = this.getMaxResizeSymbolCount(perspective, newActiveVars);

            const symbolLayers = contentLayers.filter(ly => {
                return ly.perspectiveId == perspective.id && ly.type == 'symbol' && ly.perspective_varid == perspective.varid;
            });


            if (symbolLayers.length > maxSymbols)
            {
                for (var lI = 0; lI < (symbolLayers.length - maxSymbols); lI++) {
                    var layer = symbolLayers[lI];

                    if (layer.mode == 'resize')
                    {
                        for (var l = 0; l < newData.length; l++) {
                            if (newData[l].id == layer.id)
                            {
                                newData = update(newData, {
                                    $splice: [[l, 1]]
                                });
                                break;
                            }
                        }
                    }
                    else if (layer.mode == 'autoscale')
                    {
                        for (var l = 0; l < newData.length; l++) {
                            if (newData[l].id == layer.id)
                            {
                                newData = update(newData, {
                                    [l]: {
                                        content: {
                                            $set: null
                                        }
                                    }
                                });
                                break;
                            }
                        }
                    }
                }
            }
        }

        this.setState({
            contentLayers: newData
        });

        return newData;
    }

    checkContentMaxChars(newActiveVars, currentContentLayers) {


        let contentLayers = currentContentLayers;
        if (currentContentLayers === undefined || currentContentLayers === null)
            contentLayers = this.state.contentLayers;

        let newData = contentLayers;

        for (var persI = 0; persI < this.state.designerConfig.perspectives.length; persI++) {
            const perspective = this.state.designerConfig.perspectives[persI];
            const maxChars = this.getMaxCharsCount(perspective, newActiveVars);

            const layersToLong = contentLayers.filter(ly => {
                return ly.perspectiveId == perspective.id && ly.type == 'text' && ly.content.length > maxChars && ly.perspective_varid == perspective.varid;
            });


            for (var ltlI = 0; ltlI < layersToLong.length; ltlI++) {

                for (var l = 0; l < contentLayers.length; l++) {
                    if (contentLayers[l].id == layersToLong[ltlI].id)
                    {
                        newData = update(newData, {
                            [l]: {
                                content: {
                                    $set: layersToLong[ltlI].content.substr(0, maxChars)
                                }
                            }
                        });
                        break;
                    }
                }
            }
        }


        this.setState({
            contentLayers: newData
        });


        return newData;
    }

    getMaxResizeSymbolCount(perspective, activeVars) {
        let max = 3;

        if (perspective.max_symbols > 0)
            max = perspective.max_symbols;

        if (activeVars !== null && activeVars !== undefined && activeVars.length > 0)
        {
            for (var varI = 0; varI < activeVars.length; varI++) {

                if (activeVars[varI].selectedVar === null || activeVars[varI].selectedVar === undefined)
                    continue;


                if (activeVars[varI].selectedVar.max_symbols > 0 && activeVars[varI].selectedVar.max_symbols < max)
                    max = activeVars[varI].selectedVar.max_symbols;
            }
        }

        return max;
    }

    getMaxCharsCount(perspective, activeVars)
    {
        let count = 60;


        if (perspective.max_chars > 0)
            count = perspective.max_chars;

        if (activeVars !== null && activeVars !== undefined && activeVars.length > 0)
        {
            for (var varI = 0; varI < activeVars.length; varI++) {

                if (activeVars[varI].selectedVar === null || activeVars[varI].selectedVar === undefined)
                    continue;

                if (activeVars[varI].selectedVar.max_chars > 0 && activeVars[varI].selectedVar.max_chars < count)
                    count = activeVars[varI].selectedVar.max_chars;
            }
        }

        return count;
    }

    render() {

        if (this.state.designerMode === null)
        {
            return (
                <DesignerModeSelect
                    onDesignerModeSelect={this.handleDesignerModeSelect}
                    designerHasComplex={this.state.designerHasComplex}
                    designerHasSimple={this.state.designerHasSimple}
                />
            );
        }

        if (this.state.designerConfig === null)
        {
            return (
                <div className="loader_icon">
                    <FontAwesome
                        name='circle-o-notch'
                        size='4x'
                        spin
                        style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
                    />
                </div>
            );
        }


        // MODE: 'preview' (DesignerPreview, PerspectiveSelect)
        if (this.props.designerRenderMode == 'preview')
        {
            return (
                <div>
                    <DesignerPreview
                        activeLayerIndex={this.state.activeLayerIndex}
                        activeBackground={this.state.activeBackground}
                        activePerspective={this.state.activePerspective}
                        activeColor={this.state.activeColor}
                        activeFont={this.state.activeFont}
                        activeDesignerVariants={this.state.activeDesignerVariants}
                        contentLayers={this.state.contentLayers}
                        designerRenderMode={this.props.designerRenderMode}
                        onContentLayerChange={this.handleEmptyCallback}
                        onContentLayerSelect={this.handleEmptyCallback}
                        onContentLayerRemove={this.handleEmptyCallback}
                        onSymbolSelect={this.handleEmptyCallback}
                    />
                    <DesignerPerspectiveSelect
                        activePerspective={this.state.activePerspective}
                        activeBackgroundVariant={this.state.activeBackgroundVariant}
                        backgrounds={this.state.designerConfig.backgrounds}
                        perspectives={this.state.designerConfig.perspectives.filter(
                            pers => pers.varid == this.state.activePerspective.varid
                        )}
                        onPerspectiveLayerSelect={this.handlePerspectiveLayerSelect}
                    />
                </div>
            );
        }

        // MODES: 'minipreview' and 'exportresult' (DesignerPreview)
        if (this.props.designerRenderMode == 'minipreview' || this.props.designerRenderMode == 'exportresult')
        {

            const exportScaleStyle = {};
            if (this.getExportScaling() != 1)
            {
                exportScaleStyle.WebkitTransform = 'scale(' + this.getExportScaling() + ',' + this.getExportScaling() + ')';
                exportScaleStyle.OTransform = 'scale(' + this.getExportScaling() + ',' + this.getExportScaling() + ')';
                exportScaleStyle.MsTransform = 'scale(' + this.getExportScaling() + ',' + this.getExportScaling() + ')';
                exportScaleStyle.MozTransform = 'scale(' + this.getExportScaling() + ',' + this.getExportScaling() + ')';
                exportScaleStyle.transform = 'scale(' + this.getExportScaling() + ',' + this.getExportScaling() + ')';
                exportScaleStyle.WebkitTransformOrigin = 'top left';
                exportScaleStyle.OTransformOrigin = 'top left';
                exportScaleStyle.MsTransformOrigin = 'top left';
                exportScaleStyle.MozTransformOrigin = 'top left';
                exportScaleStyle.transformOrigin = 'top left';
            }

            return (
                <DesignerPreview
                    exportScaleStyle={exportScaleStyle}
                    activeLayerIndex={this.state.activeLayerIndex}
                    activeBackground={this.state.activeBackground}
                    activePerspective={this.state.activePerspective}
                    activeColor={this.state.activeColor}
                    activeFont={this.state.activeFont}
                    activeDesignerVariants={this.state.activeDesignerVariants}
                    contentLayers={this.state.contentLayers}
                    designerExportBorder={this.props.designerExportBorder}
                    designerRenderMode={this.props.designerRenderMode}
                    onContentLayerChange={this.handleEmptyCallback}
                    onContentLayerSelect={this.handleEmptyCallback}
                    onContentLayerRemove={this.handleEmptyCallback}
                    onSymbolSelect={this.handleEmptyCallback}
                />
            );
        }

        let activeVarGroupPerspectives = this.state.designerConfig.perspectives;
        if (this.state.activePerspectiveGroupVariant !== null)
        {
            activeVarGroupPerspectives = this.state.designerConfig.perspectives.filter(
                pers => pers.varid == this.state.activePerspectiveGroupVariant.id
            );
        }
        const perspectiveEditors = activeVarGroupPerspectives.map((perspective) =>
            <DesignerPerspectiveEditor
                key={perspective.id + '_' + perspective.varid}
                perspective={perspective}
                active={perspective.id == this.state.activePerspective.id}
                activeBackgroundVariant={this.state.activeBackgroundVariant}
                activeDesignerVariants={this.state.activeDesignerVariants}
                backgrounds={this.state.designerConfig.backgrounds}
                onPerspectiveLayerSelect={this.handlePerspectiveLayerSelect}
                onContentLayerChange={this.handleContentLayerChange}
                contentLayers={this.state.contentLayers}
            />
        );

        // design confirm modal
        if (this.state.designConfirmStatus == 0)
        {
            return (
                <DesignConfirmModal
                    activeLayerIndex={this.state.activeLayerIndex}
                    selectedBackground={this.state.activeBackground}
                    perspectives={activeVarGroupPerspectives}
                    activeColor={this.state.activeColor}
                    activeFont={this.state.activeFont}
                    backgrounds={this.state.designerConfig.backgrounds}
                    activeDesignerVariants={this.state.activeDesignerVariants}
                    contentLayers={this.state.contentLayers}
                    designerRenderMode='minipreview'
                    onDesignConfirm={this.handleDesignerConfirm}
                />
            );
        }

        const persHasImage = (this.state.activePerspective.imageDimensions !== undefined && this.state.activePerspective.imageDimensions.width > 0);
        console.log('persHasImage', persHasImage);

        return (
            <div className="product_designer">
                <div className="row">
                    <div className="col-sm-2 col-lg-1 visible-lg">
                        <DesignerBackgroundSelect
                            position='preview'
                            backgrounds={this.state.designerConfig.backgrounds}
                            activePerspective={this.state.activePerspective}
                            activeBackground={this.state.activeBackground}
                            activeDesignerVariants={this.state.activeDesignerVariants}
                            onBackgroundSelect={this.handleBackgroundSelect}
                            submitMode={this.state.designerSubmitMode}
                            isDesignerAddonMode={this.state.isDesignerAddonMode}
                        />
                    </div>
                    <div className="col-sm-1 visible-sm"><br/></div>
                    <div className="col-sm-10 col-md-8">
                        <DesignerPreview
                            activeLayerIndex={this.state.activeLayerIndex}
                            activeBackground={this.state.activeBackground}
                            activePerspective={this.state.activePerspective}
                            activeColor={this.state.activeColor}
                            activeFont={this.state.activeFont}
                            activeDesignerVariants={this.state.activeDesignerVariants}
                            activeProductVar={this.state.activeProductVar}
                            contentLayers={this.state.contentLayers}
                            designerRenderMode={this.props.designerRenderMode}
                            colorPerElement={this.state.colorPerElement}
                            selectAutoscaleSymbol={this.state.selectAutoscaleSymbol}
                            selectAutoscaleColor={this.state.selectAutoscaleColor}
                            onContentLayerChange={this.handleContentLayerChange}
                            onContentLayerSelect={this.handleContentLayerSelect}
                            onContentLayerRemove={this.handleContentLayerRemove}
                            onSymbolSelect={this.handleSymbolSelect}
                            onAutoscaleColorSelect={this.handleColorSelect}
                        />
                    </div>

                    <div className="col-xs-12 visible-sm visible-xs"><br/></div>
                    <div className="clearfix visible-sm visible-xs"></div>

                    <div className="col-sm-6 visible-sm">
                        <DesignerBackgroundSelect
                            position='basket'
                            backgrounds={this.state.designerConfig.backgrounds}
                            activePerspective={this.state.activePerspective}
                            activeBackground={this.state.activeBackground}
                            activeDesignerVariants={this.state.activeDesignerVariants}
                            onBackgroundSelect={this.handleBackgroundSelect}
                            submitMode={this.state.designerSubmitMode}
                            isDesignerAddonMode={this.state.isDesignerAddonMode}
                        />
                        <DesignerColorSelect
                            position='basket'
                            colors={this.state.designerConfig.colors}
                            activeColor={this.state.activeColor}
                            onColorSelect={this.handleColorSelect}
                        />
                    </div>
                    <div className="col-sm-6 col-md-4 col-lg-3">
                        <DesignerBasketForm
                            submitMode={this.state.designerSubmitMode}
                            basketAmount={this.state.basketAmount}
                            productData={this.state.designerConfig.product}
                            activeProductVar={this.state.activeProductVar}
                            designerVars={this.state.designerConfig.variants.designer}
                            activeDesignerVariants={this.state.activeDesignerVariants}
                            onVarSelect={this.handleVarSelect}
                            onAddToBasket={this.handleAddToBasket}
                            onAmountChange={this.handleAmountChange}
                            onEditSave={this.handleEditSave}
                            isDesignerAddonMode={this.state.isDesignerAddonMode}
                            addonArticleName={this.state.addonArticleName}
                        />
                    </div>
                </div>
                <DesignerBackgroundSelect
                    position='actions'
                    backgrounds={this.state.designerConfig.backgrounds}
                    activePerspective={this.state.activePerspective}
                    activeBackground={this.state.activeBackground}
                    activeDesignerVariants={this.state.activeDesignerVariants}
                    onBackgroundSelect={this.handleBackgroundSelect}
                    submitMode={this.state.designerSubmitMode}
                    isDesignerAddonMode={this.state.isDesignerAddonMode}
                />

                {(
                    this.state.enableUserUpload && persHasImage?
                    <DesignerUserUpload
                        position='actions'
                        onUserImageSelect={this.handleUserImageSelect}
                        activePerspective={this.state.activePerspective}
                        activeBackground={this.state.activeBackground}
                        userUploadInterface={this.state.userUploadInterface}
                    />
                    : null
                )}

                <DesignerColorSelect
                    position='actions'
                    colors={this.state.designerConfig.colors}
                    activeColor={this.state.activeColor}
                    onColorSelect={this.handleColorSelect}
                />
                <DesignerFontSelect
                    fonts={this.state.designerConfig.fonts}
                    activeFont={this.state.activeFont}
                    onFontSelect={this.handleFontSelect}
                />
                {perspectiveEditors}
                <DesignerSymbolSelect
                    symbolCategories={this.state.symbolCategories}
                    activePerspective={this.state.activePerspective}
                    activeDesignerVariants={this.state.activeDesignerVariants}
                    onSymbolSelect={this.handleSymbolSelect}
                />
                <br/>
            </div>
        );
    }
  }

export default ProductDesigner;



// WEBPACK FOOTER //
// ./src/ProductDesigner.js